import Vue from "vue";
import Antd from "ant-design-vue";
import "ant-design-vue/dist/antd.css";
import App from "./App.vue";
import "./registerServiceWorker";
import router from "./router";
import VueMarkdown from "vue-markdown";
import VueLottiePlayer from "vue-lottie-player";
import axios from "axios";
import VueAxios from "vue-axios";
import Vuex from "vuex";
import storeModule from "./store";
import {setupInterceptors} from "./utils/httpInterceptors";

Vue.use(Vuex);
const store = new Vuex.Store(storeModule);

const moment = require("moment");
require("moment/locale/pl");

Vue.use(require("vue-moment"), {
    moment,
});

const myLocale = {
    Table: {
        filterConfirm: 'OK',
        filterReset: 'Reset',
        filterEmptyText: 'Brak filtrów',
        emptyText: 'Brak danych',
    },
};

Vue.config.productionTip = false;
Vue.use(Antd, VueMarkdown, VueLottiePlayer, VueAxios, axios);

new Vue({
    router,
    store,
    data: {
        locale: myLocale,
    },
    render: (h) => h(App), created() {
        setupInterceptors(store);
    },
}).$mount("#app");
